<template>
  <el-card class="page-container h-full">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="dateTime">
          <el-date-picker
            v-model="form.dateTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="personName">
          <el-input v-model="form.personName" placeholder="人员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="departmentName">
          <el-input v-model="form.departmentName" placeholder="部门名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="departmentCode">
          <el-input v-model="form.departmentCode" placeholder="部门编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="deviceName">
          <el-input v-model="form.deviceName" placeholder="设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="deviceCode">
          <el-input v-model="form.deviceCode" placeholder="设备编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="actionType">
          <el-select popper="actionType" v-model="form.actionType" placeholder="动作" clearable>
            <el-option
              v-for="item in actionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="" prop="areaCode">
          <el-input v-model="form.areaCode" placeholder="区域名称" clearable></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
          <!-- <el-button type="default" @click="exportFile">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border stripe height="calc(100% - 170px)" v-loading="tableLoading">
      <el-table-column label="序号" prop="seqNo" width="150" :align="alignType"></el-table-column>
      <el-table-column label="人员姓名" prop="personName" :align="alignType"></el-table-column>
      <el-table-column label="部门名称" prop="departmentName" :align="alignType"></el-table-column>
      <el-table-column label="部门编号" prop="departmentCode" :align="alignType"></el-table-column>
      <el-table-column label="设备编码" prop="deviceCode" :align="alignType"></el-table-column>
      <el-table-column label="设备名称" prop="deviceName" :align="alignType"></el-table-column>
      <el-table-column label="动作" prop="actionType" :align="alignType">
        <template slot-scope="{ row }">
          {{ row.actionType === 1 ? '进入' : row.actionType === 2 ? '离开' : '已签到' }}
        </template>
      </el-table-column>
      <el-table-column label="动作时间" prop="actionTime" :align="alignType"></el-table-column>
      <!-- <el-table-column label="区域名称" prop="areaName" :align="alignType"></el-table-column> -->
      <!-- <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            class="table-btn-two"
            size="mini"
            @click.stop="delRecord(scope.row)"
            :disabled="!$hasAccess('delete')">取消权限</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { IOTGateAccessRecordApi, IOTGateAccessAuthApi } from '@wiz-api/iot-device-management'
import tableHeightMixin from '@/mixins/tableHeightMixin'
import devaspService from '@/services/pageService/devasp'

const iotGateAccessRecordApi = new IOTGateAccessRecordApi()
const ioTGateAccessAuthApi = new IOTGateAccessAuthApi()

export default {
  name: 'AccessControlRecord',
  mixins: [tableHeightMixin],
  data() {
    return {
      pIid: '',
      facturerList: [],
      deviceTypeList: [],
      factureMap: {},
      deviceTypeMap: {},
      alignType: 'left',
      form: {
        personName: '',
        deviceName: '',
        deviceCode: '',
        actionType: '',
        areaCode: '',
        deviceCodes: [],
        dateTime: [],
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      areaMapCodeToName: {},
      actionType: null,
      actionTypeList: [
        {
          value: null,
          label: '全部',
        },
        {
          value: 1,
          label: '进入',
        },
        {
          value: 2,
          label: '离开',
        },
      ],
    }
  },
  computed: {
    wizIotConfig() {
      return Wiz.globalSettings.dynamicModules?.modules['wiz-iot-management-tongre']?.config || {}
    },
    deviceCodeList() {
      return this.wizIotConfig.deviceCodeList
    },
    isNanHai() {
      return this.wizIotConfig.isNanHai
    },
    actionList() {
      return this.wizIotConfig.actionList ? this.wizIotConfig.actionList : this.actionTypeList
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    // 页面初始化
    async init() {
      // await this.getAera()
      await this.getList()
    },
    async getAera() {
      const [err, res] = await devaspService.getAera({
        token: 'portal_js',
      })
      if (!err) {
        const aeraList = res.data.items
        if (Array.isArray(aeraList)) {
          aeraList.forEach((item) => {
            this.areaMapCodeToName[item.pr_code] = item.pr_name
          })
        }
      }
    },
    formatDate(row, column, cellValue) {
      if (cellValue) return this.dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    // 根据搜索条件搜索数据
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    // 重置表单数据
    reset() {
      this.$refs.form.resetFields()
      this.getList()
    },
    // 获取表单数据
    async getList() {
      if (this.form.actionType === 3) {
        this.form.deviceCodes = this.deviceCodeList
        this.actionType = null
      } else {
        this.form.deviceCodes = []
        this.actionType = this.form.actionType
      }
      this.tableLoading = true
      const [err, res] = await iotGateAccessRecordApi.getPageList({
        ...this.form,
        actionType: this.actionType,
        startTime: this.form.dateTime?.[0]
          ? this.dayjs(this.form.dateTime[0]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        endTime: this.form.dateTime?.[1]
          ? this.dayjs(this.form.dateTime[1]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        res.items.forEach((item, index) => {
          item.actionTime = item.time ? this.dayjs(item.time).format('YYYY-MM-DD HH:mm:ss') : null
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)
          // item.areaName = this.areaMapCodeToName[item.areaCode]
          if (this.isNanHai) {
            if (
              this.deviceCodeList.some((o) => {
                return o === item.deviceCode
              })
            ) {
              item.actionType = 3
            }
          }
        })
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
      }
    },
    // 导出
    exportFile() {},
    // 删除
    delRecord(row) {
      this.$confirm('是否确定取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await ioTGateAccessAuthApi.removeAuthByExternalId({
            body: {
              externalId: row.personCode,
            },
          })
          if (!err) {
            this.search()
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
